import React,{useState,useEffect} from 'react'
import Axios from 'axios';
import ProfilePic from '../ui-elements/ProfilePic';

function PostComment({surah, ayah ,refreshFunc, ayahText, cmntCat, cancelFunc, pageType}) {

    const [surahNum,setSurahNum] = useState("");
    const [ayahNum,setAyahNum] = useState("");
    const [comment,setComment]=useState("");
    const [userData,setUserData]=useState(["empty"]);
    const [userId,setUserId]=useState(null);
    const [alimToken,setAlimToken]=useState(null);
    const [isSubmitDisabled, setIsSubmitDisabled]=useState(true);
    const [profileData,setProfileData]=useState(null);
    const [showValidation,setShowValidation]=useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const initComment=()=>{
        setSurahNum(surah);
        setAyahNum(ayah);
        setAlimToken(localStorage.getItem('alim-login-token'));
        setUserId(localStorage.getItem('alim-user-email'));
        setProfileData(JSON.parse(localStorage.getItem('alim-user-data')));
    }

    const getUser=()=>{
        Axios.post(`${alimAPIBaseURI}rpc/test_func`,{},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            setUserData(data.data);
        }).catch((error)=>{
            console.log(error.response.data.message);
            if(error.response.data.message==="JWT expired")
            {
                setUserId(null)
            }
        });
    }
    
    const submitPost = () => {
        console.log(cmntCat);
        Axios.post(`${alimAPIBaseURI}rpc/insert_to_alim_comments_with_type`, {cment:comment,snum:surahNum,anum:ayahNum,cmtype:"0",cmlvl:"0",cmtime:new Date().valueOf().toString(),cmparent:"0",cmroot:"0",cmlike:"0",cmcategory:cmntCat?cmntCat:"ARB"},{headers: {"Content-Type": "application/json","Authorization":`bearer ${alimToken}`}}).then((data)=>{
            refreshFunc();
            setIsSubmitting(false);
        });
    }

    const handleComment=(e)=>{
        setComment(e.target.value);
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight+5}px`;
    }

    const handleKeyDown=(e)=> {
        if (e.key === "Enter" && !e.shiftKey && !isSubmitDisabled && !isSubmitting) {
            e.preventDefault();
            setIsSubmitting(true);
        }
        else if (e.key === "Enter" && e.shiftKey)
        {
            e.target.style.height = 'inherit';
            e.target.style.height = `${e.target.scrollHeight+5}px`;
        }
    }

    const checkSpace=(strToCheck)=>{
        if (!strToCheck.replace(/\s/g, '').length) {
            return true;
        }
        else
        {
            return false
        }
    }

    useEffect(()=>{
        const loginHandler=()=>{
            initComment();
            if (window.parent && window.parent !== window) {
                window.parent.postMessage("alim-login");
            }
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{
        // Add an event listener to listen for the custom event
        const handleAyah = (event) => {
            if(ayah==="all")
            {
                setAyahNum(event.detail);
            }
        };
  
        window.addEventListener('ayahCommentEvent',handleAyah);
  
        // Clean up the event listener on unmount
        return () => {
            window.removeEventListener('ayahCommentEvent', handleAyah);
        };
    });

    useEffect(()=>{
        if(userId!==null)
        {
            getUser();
        }
    },[userId]);

    useEffect(()=>{
        if(!checkSpace(comment)&&comment.replace(/\s/g, '').length>10)
        {
            setIsSubmitDisabled(false);
            setShowValidation(false);
        }
        else
        {
            setIsSubmitDisabled(true);
            setShowValidation(true);
        }
    },[comment]);

    useEffect(()=>{
        if(isSubmitting)
        {
            submitPost();
        }
    },[isSubmitting]);

    useEffect(()=>{
        initComment();
    },[]);
    
    if(userId!==null&&userData.length>0&&userData[0]!=="empty"&&profileData!==null)
    { 
        return (
            <div className="CreatePost">
                <div className="uploadPost">
                <div className='flex flex-col text-left'>
                        {/* <h4 className='mb-3 w-fit'>Post comment</h4> */}
                        <div className='flex flex-col'>
                            <div className="flex gap-2">
                                <ProfilePic profilePic={"load-profile"} webToken={alimToken} profileData={profileData} customSize={`w-[40px] h-[40px] z-10`}></ProfilePic>
                                <textarea onChange={(e)=>{handleComment(e)}} onKeyDown={(e)=>{handleKeyDown(e)}} rows={"1"} className='alim-comment-input' placeholder='Leave a comment...'/>
                            </div>
                            {isSubmitDisabled&&showValidation&&comment.length>0&&<p className='text-deep-red'>Minimum 10 characters required</p>}
                            <div className='flex gap-2 text-white pt-4 justify-end'>
                                <button onClick={()=>{cancelFunc(false)}} className='bg-dark-grey-index dark:bg-deep-blue w-fit px-5 py-2 w-[120px] rounded-[50px] text-sm h-[35px]'>Cancel</button>
                                <button onClick={submitPost} className={`${isSubmitDisabled?'bg-deep-red w-fit px-5 py-2 opacity-50':'bg-deep-red w-fit px-5 py-2'} w-[120px] rounded-[50px] text-sm h-[35px]`} disabled={isSubmitDisabled}>Post</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else if(userId!==null&&userData.length>0&&userData[0]==="empty")
    {
        return(
            <div>
                <div id={"alimLoader"} className="flex p-2 space-x-2 items-center justify-center h-full w-full">
                    <span className="alim-pre-loader animate-spin"></span>
                    <span className="alim-text-color-style text-2xl font-bold">Please wait.</span>
                </div>
            </div>
        )
    }
    else
    {
        return(
            <div>
                <h4 className='mb-4 text-xl'>Please login first to post comments</h4>
                <div className='flex gap-2 text-white'>
                    <button className='bg-deep-red px-5 py-2 rounded-md block w-fit' onClick={()=>{
                        window.open('/login?ref=1');
                    }}>
                        Login
                    </button>
                    <button onClick={()=>{cancelFunc(false)}} className={`bg-dark-grey-index ${pageType==="modal"?`dark:bg-light-blue`:`dark:bg-deep-blue`} rounded-md w-fit px-5 py-2 w-[120px]`}>Cancel</button>
                </div>
            </div>
        )
    }   
}
    
export default PostComment;
    